import { ReportActionTypes } from "../types/types";


export interface ReportState {
  answers: {
    data: any[];
    loading: boolean;
    error: string | null;
  };
  statuses: {
    data: any[];
    loading: boolean;
    error: string | null;
  };
  actions: {
    data: any[];
    loading: boolean;
    error: string | null;
  };
      linkedActions: {
    data: any[];
    loading: boolean;
    error: string | null;
  };
  combined: {
    loading: boolean;
    error: string | null;
  };
}

const initialState: ReportState = {
  answers: {
    data: [],
    loading: false,
    error: null,
  },
  statuses: {
    data: [],
    loading: false,
    error: null,
  },
   actions: {
    data: [],
    loading: false,
    error: null,
  },
   linkedActions: {
    data: [],
    loading: false,
    error: null,
  },
  combined: {
    loading: false,
    error: null,
  },
};

export const reports = (state = initialState, action: any): ReportState => {
  switch (action.type) {
    case ReportActionTypes.FETCH_REPORT_ANSWERS_REQUEST:
      return {
        ...state,
        answers: {
          ...state.answers,
          loading: true,
          error: null,
        },
      };

    case ReportActionTypes.FETCH_REPORT_ANSWERS_SUCCESS:
      return {
        ...state,
        answers: {
          data: action.payload.data,
          loading: false,
          error: null,
        },
      };

    case ReportActionTypes.FETCH_REPORT_ANSWERS_FAILURE:
      return {
        ...state,
        answers: {
          ...state.answers,
          loading: false,
          error: action.payload.error,
        },
      };

    case ReportActionTypes.FETCH_REPORT_STATUSES_REQUEST:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          loading: true,
          error: null,
        },
      };

    case ReportActionTypes.FETCH_REPORT_STATUSES_SUCCESS:
      return {
        ...state,
        statuses: {
          data: action.payload.data,
          loading: false,
          error: null,
        },
      };

    case ReportActionTypes.FETCH_REPORT_STATUSES_FAILURE:
      return {
        ...state,
        statuses: {
          ...state.statuses,
          loading: false,
          error: action.payload.error,
        },
      };

    case ReportActionTypes.FETCH_REPORT_DATA_REQUEST:
      return {
        ...state,
        answers: {
          ...state.answers,
          loading: true,
          error: null,
        },
        statuses: {
          ...state.statuses,
          loading: true,
          error: null,
        },
        combined: {
          loading: true,
          error: null,
        },
      };

    case ReportActionTypes.FETCH_REPORT_DATA_SUCCESS:
      return {
        ...state,
        answers: {
          data: action.payload.answers,
          loading: false,
          error: null,
        },
        statuses: {
          data: action.payload.statuses,
          loading: false,
          error: null,
        },
        combined: {
          loading: false,
          error: null,
        },
      };

    case ReportActionTypes.FETCH_REPORT_DATA_FAILURE:
      return {
        ...state,
        answers: {
          ...state.answers,
          loading: false,
          error: action.payload.error,
        },
        statuses: {
          ...state.statuses,
          loading: false,
          error: action.payload.error,
        },
        combined: {
          loading: false,
          error: action.payload.error,
        },
      };



       case ReportActionTypes.FETCH_LINKED_ACTIONS_REQUEST:
      return {
        ...state,
        linkedActions: {
          ...state.linkedActions,
          loading: true,
          error: null,
        },
      };

    case ReportActionTypes.FETCH_LINKED_ACTIONS_SUCCESS:
      return {
        ...state,
        linkedActions: {
          data: action.payload.data,
          loading: false,
          error: null,
        },
      };

    case ReportActionTypes.FETCH_LINKED_ACTIONS_FAILURE:
      return {
        ...state,
        linkedActions: {
          ...state.linkedActions,
          loading: false,
          error: action.payload.error,
        },
      };

    default:
      return state;
  }
};